import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { IAction } from "@faire/web-api--source/indigofair/data/IAction";
import { ILoggingAction } from "@faire/web-api--source/indigofair/data/ILoggingAction";
import React from "react";
import { SDUIOnViewHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnViewHandler/SDUIOnViewHandler";
import { ActionLoggingEventParams } from "@faire/retailer/components/SDUI/__internal__/types";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { getCssFromStyle } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/getCssFromTileStyle";
import { SDUITileRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/SDUITileRenderer";
export var SDUIGridV2Tile = function(param) {
    var tile = param.tile, tileRef = param.tileRef, loggingData = param.loggingData, rowSpacingPixels = param.rowSpacingPixels, logTileBatchView = param.logTileBatchView, shouldSetIsScrollingTopToFalseOnView = param.shouldSetIsScrollingTopToFalseOnView;
    var _tile_logging_data, _tile_logging_data_tile_position, _tile_logging_data1, _tile_logging_data2;
    var _tile_logging_data_instance_identifier;
    var actionLoggingParams = ActionLoggingEventParams.build(_object_spread_props(_object_spread({}, loggingData), {
        action_content: (_tile_logging_data = tile.logging_data) === null || _tile_logging_data === void 0 ? void 0 : _tile_logging_data.instance_identifier,
        action_positions: (_tile_logging_data1 = tile.logging_data) === null || _tile_logging_data1 === void 0 ? void 0 : (_tile_logging_data_tile_position = _tile_logging_data1.tile_position) === null || _tile_logging_data_tile_position === void 0 ? void 0 : _tile_logging_data_tile_position.toString(),
        action_instance_identifier: (_tile_logging_data_instance_identifier = (_tile_logging_data2 = tile.logging_data) === null || _tile_logging_data2 === void 0 ? void 0 : _tile_logging_data2.instance_identifier) !== null && _tile_logging_data_instance_identifier !== void 0 ? _tile_logging_data_instance_identifier : ""
    }));
    var _actionLoggingParams_action_content;
    var onViewActions = _to_consumable_array(tile.on_view).concat(_to_consumable_array(logTileBatchView ? [
        IAction.build({
            log_event: ILoggingAction.build({
                event_name: logTileBatchView.event_name,
                parameters: logTileBatchView.parameters.concat((_actionLoggingParams_action_content = actionLoggingParams.action_content) !== null && _actionLoggingParams_action_content !== void 0 ? _actionLoggingParams_action_content : [])
            })
        })
    ] : []));
    return /*#__PURE__*/ _jsx(SDUIOnViewHandler, {
        onViewActions: onViewActions,
        loggingData: actionLoggingParams,
        componentStyle: _object_spread({
            height: "100%",
            padding: "".concat(rowSpacingPixels / 2, "px 0px")
        }, getCssFromStyle(tile.style)),
        ref: tileRef,
        logLegacyViewEvent: true,
        logSDUIViewEvent: true,
        shouldSetIsScrollingTopToFalseOnView: shouldSetIsScrollingTopToFalseOnView,
        children: /*#__PURE__*/ _jsx(SDUITileRenderer, {
            tileElement: tile,
            loggingData: loggingData
        })
    });
};
